import { create } from 'zustand'
import type { Provider, DiscoverySummary } from '@/lib/types'

export type DiscoveryStatus = 'idle' | 'running' | 'complete' | 'error'
export type DiscoveryStepStatus = 'idle' | 'in_progress' | 'done' | 'error'
export type DiscoveryStepKey = 'load_pipeline' | 'npi_search' | 'build_results'

interface DiscoveryStreamState {
  status: DiscoveryStatus
  steps: Record<DiscoveryStepKey, DiscoveryStepStatus>
  providers: Provider[]
  summary: DiscoverySummary | null
  errorMessage: string | null
  setStatus: (status: DiscoveryStatus) => void
  setStep: (step: DiscoveryStepKey, stepStatus: DiscoveryStepStatus) => void
  setProviders: (providers: Provider[]) => void
  setSummary: (summary: DiscoverySummary) => void
  setErrorMessage: (message: string) => void
  reset: () => void
}

const initialState = {
  status: 'idle' as DiscoveryStatus,
  steps: {
    load_pipeline: 'idle',
    npi_search: 'idle',
    build_results: 'idle',
  } as Record<DiscoveryStepKey, DiscoveryStepStatus>,
  providers: [] as Provider[],
  summary: null,
  errorMessage: null,
}

export const useDiscoveryStore = create<DiscoveryStreamState>((set) => ({
  ...initialState,
  setStatus: (status) => set({ status }),
  setStep: (step, stepStatus) =>
    set((s) => ({ steps: { ...s.steps, [step]: stepStatus } })),
  setProviders: (providers) => set({ providers }),
  setSummary: (summary) => set({ summary }),
  setErrorMessage: (errorMessage) => set({ errorMessage }),
  reset: () => set(initialState),
}))
